import React from 'react';
import Box from "../Box/Box";
import PropTypes from 'prop-types';
import Notify from "../../services/Notify";
import Loading from "../Loading/Loading";
import CompanyService from "../../services/CompanyService";
import FormButtons from "../Form/FormButtons";
import {Col, Row} from "react-bootstrap";
import {InputWithLabel} from "../Form/InputWithLabel";

class CompanyForm extends React.Component {

    companyService = new CompanyService();

    constructor(props) {
        super(props);
        this.state = {};
        this.latitude = React.createRef();
        this.longitude = React.createRef();
        this.domain = React.createRef();
        this.name = React.createRef();
    }

    componentDidMount() {
        const {match} = this.props;
        const id = match.params.id;
        if (id) {
            const state = this.state;
            state.loading = true;
            this.setState(state);
            this.companyService.findById(id).then(
                data => this.setState({loading: false, entity: data}),
                error => this.setState({
                    loading: false,
                    message: 'Error'
                }) && Notify.error('Falha ao buscar entidade: ', error)
            )
        }
    }

    submitForm() {
        const existingEntity = this.state.entity && this.state.entity.id;
        const entityVersion = this.state.entity && this.state.entity.version;
        const entity = {
            id: existingEntity,
            latitude: this.latitude,
            longitude: this.longitude,
            domain: this.domain,
            name: this.name,
            version: entityVersion
        };
        this.setState({loading: true, message: 'Salvando...'});
        this.setState({loading: true});
        this.companyService.save(entity).then(
            () => {
                this.props.history.goBack();
                Notify.success('Entidade salva');
            },
            (error) => {
                Notify.error('Falha ao salvar:', error);
                this.setState({loading: false, entity});
                this.setState({loading: false, entity, message: null});
            }
        );
    }

    render() {
        const {loading, entity, message} = this.state;
        const {history} = this.props;

        if (loading) {
            return <Loading message={message}/>
        }
        if (message) {
            return <h2>{message}</h2>
        }
        return (
            <Box info>
                <form ref={form => (this.form = form)} onSubmit={event => {
                    event.preventDefault();
                    this.submitForm()
                }}>
                    <InputWithLabel
                        inputType="text"
                        className="form-control"
                        placeholder="Nome da empresa"
                        required
                        name="name"
                        label="Nome"
                        onChangeText={text => this.name = text}
                        inputRef={this.name}
                        defaultValue={entity && entity.name}
                    />
                    <InputWithLabel inputType="text"
                                    className="form-control"
                                    placeholder="google.com"
                                    id="domain"
                                    name="domain"
                                    label="Dominio"
                                    onChangeText={text => this.domain = text}
                                    inputRef={this.domain}
                                    defaultValue={entity && entity.domain}
                    />
                    <Row className="w-100">
                        <Col md={6}>
                            <InputWithLabel
                                inputType="number"
                                className="form-control"
                                placeholder="Digite a Latitude"
                                id="Latitude"
                                onlyNumbers
                                name="latitude"
                                label="Latitude"
                                onChangeText={text => this.latitude = (text)}
                                inputRef={this.latitude}
                                defaultValue={entity && entity.latitude}

                            />
                        </Col>
                        <Col md={6}>
                            <InputWithLabel inputType="number"
                                            className="form-control"
                                            placeholder="Digite a Longitude"
                                            onlyNumbers
                                            id="Longitude"
                                            name="longitude"
                                            label="Longitude"
                                            onChangeText={text => this.longitude = (text)}
                                            inputRef={this.longitude}
                                            defaultValue={entity && entity.longitude}

                            />
                        </Col>
                    </Row>
                    <FormButtons history={history}/>

                </form>
            </Box>);
    }
}

CompanyForm.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default CompanyForm;


// WEBPACK FOOTER //
// ./src/component/Company/CompanyForm.js